import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { fetchCaptcha } from "../api";
import { ECaptchaConstant } from "../constants";
/**
 * Хок, который отвечает за отрисовку капчи
 */
export function withCaptchaLogic(WrappedComponent) {
  var Component = function Component(props) {
    var _state$pic;
    var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];
    var _useState3 = useState(Math.round(Math.random() * 100)),
      _useState4 = _slicedToArray(_useState3, 2),
      _seed = _useState4[0],
      setSeed = _useState4[1];
    useEffect(function () {
      fetchCaptcha({
        height: ECaptchaConstant.DefaultCaptchaHeight,
        width: ECaptchaConstant.DefaultCaptchaWidth,
        key: state.captchaKey
      }).then(function (data) {
        var _data$key, _data$captcha;
        setState({
          captchaKey: (_data$key = data.key) !== null && _data$key !== void 0 ? _data$key : '',
          pic: (_data$captcha = data.captcha) !== null && _data$captcha !== void 0 ? _data$captcha : ''
        });
      }).catch(function (e) {
        console.error(e);
        setState({});
      });
    }, [_seed]);
    var onRefresh = function onRefresh() {
      setSeed(Math.round(Math.random() * 100));
    };
    return /*#__PURE__*/React.createElement(WrappedComponent, {
      captchaKey: state.captchaKey,
      inputProps: props,
      onRefresh: onRefresh,
      pic: (_state$pic = state.pic) !== null && _state$pic !== void 0 ? _state$pic : ''
    });
  };
  return Component;
}